<template>
  <v-container
    fluid
    class="mb-6"
    grid-list-xl
  >
    <v-layout
      row
      wrap
      class="text-center mb-4"
    >
      <v-flex xs12>
        <v-icon x-large>
          mdi-help
        </v-icon>
        <h2 class="display-2">
          Hilfe
        </h2>
      </v-flex>
      <page-loading :is-page-loading="this.$store.state.pageLoading" />
    </v-layout>
    <v-layout
      row
      wrap
    >
      <v-flex
        xs12
        sm6
        offset-sm3
        class="mb-6"
      >
        <v-card flat>
          <v-card-title
            primary-title
            class="mb-0 pb-0"
          >
            <h3 class="headline mb-2">
              <v-icon>mdi-delete</v-icon> Cache / Session leeren
            </h3>
            <div>
              Bei einer neuen Version kommt es öfters mal vor, dass die im Browser gespeicherten Daten veraltet sind.<br>Meist passiert dass, wenn man sich nicht richtig ausloggt.
            </div>
          </v-card-title>
          <v-card-text>
            <div>
              <v-btn
                class="ml-0 mt-0"
                color="error"
                @click.native="cleareKMOCache"
              >
                Browserdaten vom KMO-Spiel jetzt löschen  <v-icon right dark>
                  mdi-delete
                </v-icon>
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'Help',
  metaInfo: {
    title: 'Hilfe'
  },
  data () {
    return {
    }
  },
  methods: {
    cleareKMOCache: function () {
      window.sessionStorage.removeItem(process.env.VUE_APP_KMO_SESSION_NAME)
      window.sessionStorage.clear()
      window.location.href = '/logout'
    }
  }
}
</script>
